var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.2,
    height: 58.19,
    viewBox: "0 0 52.2 58.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "assess") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.26,
    cy: 6.7,
    r: 1.23,
    fill: "#004f71"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.98,
    cy: 6.7,
    r: 1.23,
    fill: "#004f71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497,478.84a1.23,1.23,0,1,0-1.23-1.23A1.23,1.23,0,0,0,497,478.84Z",
    transform: "translate(-474.34 -470.91)",
    fill: "#004f71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.67,478.84a1.23,1.23,0,1,0-1.22-1.23A1.23,1.23,0,0,0,503.67,478.84Z",
    transform: "translate(-474.34 -470.91)",
    fill: "#004f71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525.44,485.9a5.05,5.05,0,0,0-7.1-.8l-5.53,4.4V472.41a1.5,1.5,0,0,0-1.5-1.5H475.84a1.5,1.5,0,0,0-1.5,1.5v55.18a1.5,1.5,0,0,0,1.5,1.5h35.47a1.5,1.5,0,0,0,1.5-1.5V508.33l10-7.93a1.49,1.49,0,0,0,.26-2.09l-2-2.52,3.5-2.79a5,5,0,0,0,.81-7.1Zm-48.1-12h.56s0,0,0,.08a1.23,1.23,0,1,0,2.46,0s0-.06,0-.08h4.3s0,0,0,.08a1.23,1.23,0,0,0,2.46,0s0-.06,0-.08h5.22a.19.19,0,0,0,0,.08,1.23,1.23,0,1,0,2.45,0s0-.06,0-.08H499s0,0,0,.08a1.23,1.23,0,1,0,2.45,0s0-.06,0-.08h5.12s0,0,0,.08a1.23,1.23,0,1,0,2.45,0s0-.06,0-.08h.86V481h-.91a1.22,1.22,0,0,0-1.16-.89,1.2,1.2,0,0,0-1.16.89h-5.24a1.19,1.19,0,0,0-2.31,0h-4.4a1.2,1.2,0,0,0-2.32,0H487a1.2,1.2,0,0,0-2.32,0h-4.4a1.2,1.2,0,0,0-2.32,0h-.61Zm32.47,52.18H477.34v-42h32.47v7.81l-19.34,15.39a1.46,1.46,0,0,0-.44.57l-2.42,5.48a1.47,1.47,0,0,0,0,1.11L486,515.69a1.5,1.5,0,0,0,.94,2.67,1.47,1.47,0,0,0,.93-.33l1.55-1.23a1.5,1.5,0,0,0,.85.26,1.37,1.37,0,0,0,.4,0l5.56-1.56a1.4,1.4,0,0,0,.53-.27l13-10.38Zm0-25.13-14.3,11.38-2.62-3.15,16.92-13.47,3-2.39,1.62-1.29,2.51,3.25-4.13,3.29Zm3,3.54v-2.09l6-4.75,1,1.31Zm10.71-15.22a2,2,0,0,1-.76,1.37l-3.47,2.77-2.51-3.25,3.43-2.73a2.06,2.06,0,0,1,2.88.33A2,2,0,0,1,523.52,489.28Z",
    transform: "translate(-474.34 -470.91)",
    fill: "#004f71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssess);
export default __webpack_public_path__ + "static/media/assess.f6f631be7a2c8908661300e76f57676d.svg";
export { ForwardRef as ReactComponent };